<template>
  <li :class="['node-tree', { dashed: isOpen }]">

    <div
      @click.stop="highlightField(node)"
      class="subdivision"
      :class="[{'active': isActiveId===node.id}, {'highlight-delete' : node.deleted_at}]"
      v-click-outside="vcoConfig"
    >
      <button
        v-if="node.children && node.children.length"
        :class="{'highlight-delete' : node.deleted_at}"
        @click.stop="isOpen=!isOpen"
      >
        <svgicon :icon="isOpen ? 'minus' : 'plus'" width="20px"></svgicon>
      </button>
      <span style="margin-left: 13px">{{ node.name }}</span>
    </div>

    <transition name="slide-fade">
      <ul
        v-show="isOpen"
        class="children"
      >
        <Subdivision
          v-for="child in node.children"
          :node="child"
          :key="child.id"
          :routeName="routeName"
          class="children__item"
          :isActiveId="isActiveId"
          @highlightField="highlightField"
        ></Subdivision>
      </ul>
    </transition>
  </li>
</template>

<script>
export default {
  name: "Subdivision",
  props: {
    node: Object,
    routeName: {
      type: String,
      default: "",
    },
    isActiveId: {
      type: [Number, String]
    }
  },
  data() {
    return {
      isOpen: false,
      vcoConfig: {
        handler: this.outsideHandler,
        middleware: this.middleware,
        events: ['dblclick', 'click']
      },
    };
  },
  computed: {},
  methods: {
    highlightField (node) {
      this.$emit('highlightField', node)
    },
    outsideHandler (event) {
      this.$emit('outsideHandler', event)
    },
    middleware (event) {
      return !event.target.className.includes('subdivision')
    },
  }
};
</script>

<style lang="scss" scoped>
.node-tree {
  position: relative;

  .subdivision {
    display: flex;
    align-items: center;
    border: 1px solid #b8cad5;
    border-radius: 4px;
    height: 100%;
    margin-bottom: 12px;
    width: 472px;
    height: 48px;
    position: relative;
    z-index: 100;
    transition: 0.4s;
    background: white;
    cursor: pointer;

    button {
      height: 100%;
      width: 45px;
      color: $blue;
      border-right: 1px solid #b8cad5;
      border-radius: 4px 0px 0px 4px;
      background: white;

      &.highlight-delete{
        background: rgba(255, 68, 67, 0.1);
      }
    }

    &:hover {
      background: #E8F2F8;
    }
    &.active {
      background: #E8F2F8;
      color: $blue;
    }

    &.highlight-delete{
       background: rgba(255, 68, 67, 0.6);

      &:hover, &.active {
        background: rgba(255, 68, 67, 0.3);
      }
    }
  }



  &.dashed::after {
    content: "";
    position: absolute;
    top: 48px;
    left: 22.5px;
    border: 1px dashed $gray;
    height: calc(100% - 72px);
    animation: dashedTop 0.1s;
  }

  @keyframes dashedTop {
    from {
      height: 0px;
    }

    to {
      height: calc(100% - 72px);
    }
  }

  .children {
    margin-left: 45px;

    .children__item {
      &::before {
        content: "";
        position: absolute;
        top: 24px;
        right: 100%;
        width: 22.5px;
        border: 1px dashed $gray;
        animation: dashedRight 0.3s;
      }
      &:last-of-type {
        margin-bottom: 32px;
      }
      &:last-of-type::before {
        content: "";
        position: absolute;
        top: 24px;
        right: 100%;
        width: 22.5px;
        height: 100%;
        border: none;
        border-left: 2px solid #f1f6f9;
        border-top: 2px dashed $gray;
        animation: dashedRight 0.3s;
        z-index: 1;
      }

      @keyframes dashedRight {
        from {
          width: 0px;
        }

        to {
          width: 22.5px;
        }
      }
    }
  }
}
</style>
